import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import { ArrowDropDown } from "@mui/icons-material";
import { useRTL } from "hooks/isRTL";
import { exportReport, exportReportOrder } from "services/exportService";

const ExportButton = ({ reportType }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useRTL();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExport = async (format) => {
    reportType === "orderlist"
      ? await exportReportOrder(reportType, format)
      : await exportReport(reportType, format);
    handleClose();
  };

  return (
    <>
      <Button
        endIcon={<ArrowDropDown />}
        onClick={handleClick}
        sx={{
          marginTop: "0rem",
          padding: "0.25rem 0.75rem",
          backgroundColor: "transparent",
          minWidth: 0,
          color: "var(--primary)",
          fontSize: "1rem",
          fontWeight: 600,
          lineHeight: "1.5rem",
          height: "35px",
          width: "122px",
          whiteSpace: "nowrap",
          border: "1px solid",
          "&:hover": {
            backgroundColor: "#2A3467",
            color: "#FFFFFF",
            border: "1px solid rgb(14, 20, 51)",
          },
        }}
      >
        {t("exportAs")}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        PaperProps={{
          sx: { borderRadius: "0.5rem", minWidth: "8rem" },
        }}
        MenuListProps={{
          sx: {
            padding: "0.5rem 0",
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem",
          },
        }}
      >
        <MenuItem onClick={() => handleExport("csv")}>CSV</MenuItem>
        <MenuItem onClick={() => handleExport("pdf")}>PDF</MenuItem>
        <MenuItem onClick={() => handleExport("xlsx")}>Excel</MenuItem>
      </Menu>
    </>
  );
};

export default ExportButton;
